export default "__VITE_ASSET__e838cf6e__"